import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllvalueAdditionFiveResponse, ValueAdditionFiveDto, valueAdditionFiveResponse, ValueAdditionIdModel, valueAdditionIdResponse } from '@gtpl/shared-models/masters';
import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions } from 'apps/services/logger/logger-functions';
import { Raw, Repository } from 'typeorm';
import { ValueAddFiveTypeAdapter } from './dto/value-addition-five.adapter';
import { ValueAdditionFiveDTO } from './dto/value-addition-five.dto';
import { ValueAdditionFiveRequest } from './dto/value-addition-five.request';
import { ValueAdditionFiveType } from './value-addition-five.entity';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';


@Injectable()
export class ValueAddition5TypesService {
  getAllActiveValAddTypes(): AllvalueAdditionFiveResponse | PromiseLike<AllvalueAdditionFiveResponse> {
    throw new Error('Method not implemented.');
  }
    constructor(
      private logService:LogsService,
        @InjectRepository(ValueAdditionFiveType) private foodTypeRepository: Repository<ValueAdditionFiveType>,
        private valAddFiveAdapter: ValueAddFiveTypeAdapter,
      ) { }

    //create method
      async createValAddFiveType(valAddDto:ValueAdditionFiveDTO,isUpdate:boolean,@Req() request:Request): Promise<valueAdditionFiveResponse> {
        try {
            let previousValue;
        if (!isUpdate) {
   
            const valAddFiveTypeEntity = await this.getDuplicateValAddFiveType(valAddDto.code);
          if (valAddFiveTypeEntity) {
            throw new valueAdditionFiveResponse(false,11104, 'Value Addition Type already exists');
          }
        }
        else {
            const certificatePrevious = await this.foodTypeRepository.findOne({where:{valueAdditionFiveId:valAddDto.valueAdditionFiveId}})
            previousValue = certificatePrevious.code+','+certificatePrevious.name;
            const valAddFiveTypeEntity = await this.getDuplicateValAddFiveType(valAddDto.code);
          if (valAddFiveTypeEntity) {
              if(valAddFiveTypeEntity.valueAdditionFiveId!=valAddDto.valueAdditionFiveId){
                throw new valueAdditionFiveResponse(false,11104, 'Value Addition Type already exists');
              }
          }
        }
        const convertedvalAddTypeEntity: ValueAdditionFiveType = this.valAddFiveAdapter.convertDtoToEntity(valAddDto,isUpdate);
        const savedValAddEntity: ValueAdditionFiveType = await this.foodTypeRepository.save(convertedvalAddTypeEntity);
        const savedValAddTypeDto: ValueAdditionFiveDTO = this.valAddFiveAdapter.convertEntityToDto(savedValAddEntity);
       
         if (savedValAddTypeDto) {
           const present = savedValAddTypeDto.code+','+savedValAddTypeDto.name
          const response = new valueAdditionFiveResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Value Addition  Type Updated Successfully':'Value Addition  Type Created Successfully',savedValAddTypeDto);
          const name= isUpdate? 'updated':'created'
          const displayValue = isUpdate? 'Value Addition Type Updated Successfully': 'Value Addition Type Created Successfully'
          const userName = isUpdate? savedValAddTypeDto.updatedUser :savedValAddTypeDto.createdUser;
          const newLogDto = new LogsDto(1,name, 'ValueAdditionFiveDTO', savedValAddTypeDto.valueAdditionFiveId, true, displayValue,userName,previousValue,present)
          let res = await this.logService.createLog(newLogDto);
          console.log(res);
          return response;
        } else {
          throw new valueAdditionFiveResponse(false,11106,'Value Addition Five Type saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all  val addition one types details  
     * @returns all the val addition one type details .
     */
    // @LogActions({ isAsync: true })
        async getAllValAddFiveTypes(req?:UserRequestDto): Promise<AllvalueAdditionFiveResponse> {  
            try {
                const valAddDto: ValueAdditionFiveDto[] = [];
                // retrieves all plants
                const valAddOneTypeEntities: ValueAdditionFiveType[] = await this.foodTypeRepository.find({
                    order: { name: "ASC" },
                });
                //   console.log(valAddOneTypeEntities);
                if (valAddOneTypeEntities.length>0) {
                    valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                    const convertedValAddTypeDto: ValueAdditionFiveDto = this.valAddFiveAdapter.convertEntityToDto(valAddOneTypeEntity);
                    valAddDto.push(convertedValAddTypeDto);
                    });
                    const response = new AllvalueAdditionFiveResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                    if(req?.createdUser){
                        const newLogDto = new LogsDto(1,'view', 'ValueAdditionFiveDTO', 0, true, 'Value Addition Types retrieved successfully',req.createdUser,'','')
                        let res = await this.logService.createLog(newLogDto);
                        console.log(res);
                    }
                    return response;
                } else {
                    //   console.log('yest')
                    throw new valueAdditionFiveResponse(false,99998, 'No Records Found');
                }
        } catch (err) {
        throw err;
        }
    }
    async getAllActiveValAddFiveTypes(): Promise<AllvalueAdditionFiveResponse> {
        // const page: number = 1;
        try {
            const valAddDto: ValueAdditionFiveDto[] = [];
            //retrieves all companies
            const valAddOneTypeEntities: ValueAdditionFiveType[] = await this.foodTypeRepository.find({ order: { name: 'ASC' },where:{isActive:true},
           });
         console.log(valAddOneTypeEntities)
            if (valAddOneTypeEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                    const convertedValAddTypeDto: ValueAdditionFiveDto = this.valAddFiveAdapter.convertEntityToDto(
                        valAddOneTypeEntity
                    );
                    valAddDto.push(convertedValAddTypeDto);
                });
                const response = new AllvalueAdditionFiveResponse(true, 11108, "ValAddFiveTypes retrieved successfully", valAddDto);
                return response;
            } else {
                throw new valueAdditionFiveResponse(false,99998, 'Data not found'); valAddDto
            }
        } catch (err) {
            throw err;
        }
    }

    /**
     * It deactivates value addition value  type 
     * @param foodTypeRequest addition  type  as string
     * @returns true or false
     */
    //  @LogActions({isAsync: true})
     async activateOrDeactivateValAddFiveType(valAddOneReq: ValueAdditionFiveRequest): Promise<valueAdditionFiveResponse> {
         try {
             const FoodTypeExists = await this.getValAddTypeById(valAddOneReq.valueAdditionFiveId);
             if (FoodTypeExists) {
                 if (valAddOneReq.versionFlag !== FoodTypeExists.versionFlag) {
                     throw new valueAdditionFiveResponse(false,10113, 'Someone updated the current Value Addition Type information.Refresh and try again');
                 } else {
                     
                         const foodTypeSatatus =  await this.foodTypeRepository.update(
                             { valueAdditionFiveId: valAddOneReq.valueAdditionFiveId },
                             { isActive: valAddOneReq.isActive,updatedUser: valAddOneReq.updatedUser });
                        
                         if (FoodTypeExists.isActive) {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionFiveResponse = new valueAdditionFiveResponse(true, 10115, 'Value Addition Type is de-activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionFiveResponse(false,10111, 'Value addition Type is already deactivated');
                             }
                         } else {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionFiveResponse = new valueAdditionFiveResponse(true, 10114, 'Value addition type is activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionFiveResponse(false,10112, 'Value addition type is already  activated');
                             }
                         }
                     // }
                 }
             } else {
                 throw new valueAdditionFiveResponse(false,99998, 'No Records Found');
             }
         } catch (err) {
             throw err;
         }
     }

    async getValAddFiveType(valAddFiveId: number): Promise<ValueAdditionFiveType> {
    //  console.log(employeeId);
        const response = await this.foodTypeRepository.findOne({
        where: {valueAdditionFiveId: Raw(alias => `value_addition_five_id = '${valAddFiveId}'`)},
        });
        // console.log(response);valueAdditionOneId: Raw(alias => `value_addition_one_id = '${valueAdditionOneId}'`)
        if (response) {
        return response;
        } else {
        return null;
        }
    }

    async getDuplicateValAddFiveType(valAddFiveCode: string): Promise<ValueAdditionFiveType> {
        //  console.log(employeeId);
            const response = await this.foodTypeRepository.findOne({
            where: {valueAdditionFiveId: Raw(alias => `code = '${valAddFiveCode}'`)},
            });
            // console.log(response);valueAdditionOneId: Raw(alias => `value_addition_one_id = '${valueAdditionOneId}'`)
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    async getValAddTypeById(valueAdditionId: number): Promise<ValueAdditionFiveType> {
        //  console.log(employeeId);
            const Response = await this.foodTypeRepository.findOne({
            where: {valueAdditionFiveId: valueAdditionId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

     /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     */
    async getValAddDetails(valueAdditionId: number): Promise<valueAdditionIdResponse> {
        const valAddData = await this.foodTypeRepository.findOne({select: ['name','code'], where: {valueAdditionFiveId: valueAdditionId}});
        if(valAddData) {
            const modelResponse = new ValueAdditionIdModel(valAddData.name, valAddData.code);
            const response = new valueAdditionIdResponse(true, 11208, "Value Addition Types retrieved successfully", modelResponse);
            return response;
        } else {
            return null;
        }   
    }      
}
